export default "__VITE_ASSET__vtuJIylJ__"